import GalleryItem from './gallery-item'

export default GalleryItem
